const LOGIN = "/login";
const HOME = "/home";
const CHANNEL = "/channel";
const KPIS = "/kpis";
const ENTITY_ZOOMED = "/entity-zoomed";
const SECTOR_ZOOMED = "/sector-zoomed";
const CHANNEL_ZOOMED = "/channel-zoomed";
const SERVICES = "/services";
const SERVICE_CENTERS = "/service-centers";

export default {
  LOGIN,
  HOME,
  CHANNEL,
  KPIS,
  ENTITY_ZOOMED,
  SECTOR_ZOOMED,
  CHANNEL_ZOOMED,
  SERVICES,
  SERVICE_CENTERS
};
